module.exports = __webpack_public_path__ + "static/media/116.8e7a218f.jpg";